import { render } from "./VoteResultRender.vue?vue&type=template&id=b5a23e92&ts=true"
import script from "./VoteResultRender.vue?vue&type=script&lang=ts"
export * from "./VoteResultRender.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__